import { render } from "./slogan-modal.vue?vue&type=template&id=381916ef&scoped=true&ts=true"
import script from "./slogan-modal.vue?vue&type=script&lang=ts"
export * from "./slogan-modal.vue?vue&type=script&lang=ts"

import "./slogan-modal.vue?vue&type=style&index=0&id=381916ef&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381916ef"]])

export default __exports__